<template>
  <div class="w-100">
    <div class="navigation_container">
      <div class="navigation_content">
        <router-link to="/">
          <div class="navigation_logo">
          </div>
        </router-link>
        <div class="navigation_right">
          <div class="dropdown header_user-content show">
            <div class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
              <div class="header_user-logo"></div>
            </div>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" @click.prevent="sign('in')" href="#">Sign in</a>
              <!-- <a class="dropdown-item" @click.prevent="sign('up')" href="#">Sign up</a> -->
            </div>
          </div>
          <div class="hamburger">
            <a class="main-nav-toggle" :class="{'active-menu': btn_status}" href="#main-nav" @click="changeBurger()"><i>Menu</i></a>
            <div class="menu_content" :class="{'active_menu': btn_status}">
              <ul class="header_links">
                <li class="header_link-item" @click="goTo('/blogs')">Blogs</li>
                <li class="header_link-item" @click="goTo('/contact_us')">Contact us</li>
                <li class="header_link-item" @click="goTo('/about_us')">About us</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      btn_status: false
    }
  },
  methods: {
    changeBurger() {
      this.btn_status = !this.btn_status
    },
    sign(item) {
      this.$router.push(`/sign_${item}`)
    },
    goTo(item) {
      this.$router.push(item)
      // switch(item) {
      //   case '/blogs':
      //     this.router.push('/blogs')
      //     break;
      //   case y:
      //     this.router.push('/contact_us')
      //     break;
      //   case y:
      //     this.router.push('/about_us')
      //     break;
      //   default:
      //     this.router.push('/')
      // }
    }
  }
}
</script>

<style scoped lang="scss">
.navigation {
  &_container {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    position: fixed;
    top: 0;
    z-index: 3;
    background: linear-gradient(180deg, #000 -46.5%, rgba(0, 0, 0, 0.00) 100%);
  }
  &_content {
    max-width: 1700px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 1680px) {
      max-width: 85%;
    }
    @media screen and (max-width: 768px) {
      max-width: 90%;
    }


    & .hamburger {
      height: 26px;
      top: 5px;
      margin-right: 27px;
      position: relative;
      display: inline-block;
      & .menu_content {
        position: absolute;
        top: 45px;
        right: -35px;
        background: linear-gradient(360deg, rgba(0,0,0,0.8) -46.5%, rgba(0, 0, 0, 0.1) 100%);
        border-radius: 8px;
        opacity: 0;
        visibility: hidden;
        transform: translateY(-200px);
        transition: .3s;
        &.active_menu {
          transform: translateY(0);
          opacity: 1;
          visibility: visible;
          transition: .3s;
        }
        & .header {
          &_links {
            display: flex;
            flex-direction: column;
            padding: 5px 0;
            align-items: flex-start;
            width: 170px;
            @media screen and (max-width: 768px) {
              width: 180px;
            }
          }
          &_link-item {
            width: 100%;
            padding: 10px 40px;
            border-bottom: 0.5px solid rgba(62, 61, 61, 0.4);
            list-style-type: none;
            font-weight: 600;
            color: #fff;
            cursor: pointer;
            &:hover {
              background: rgba(0, 0, 0, 0.4);
            }
          }
        }
      }
      a.main-nav-toggle {
        display: block;
        width: 28px;
        height: 16px;
        left: 0;
        position: absolute;
        top: 0;
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);

        &:after,
        &:before {
          content: '';
          position: absolute;
          top: 0;
          height: 0;
          border-bottom: 3px solid #fff;
          border-radius: 8px;
          left: 0;
          right: 0;
          transition: all ease-out 0.3s;
        }

        &:after {
          top: 100%;
          width: 75%;
        }
        &:before {
          width: 50%;
        }

        i {
          display: block;
          text-indent: 100%;
          overflow: hidden;
          white-space: nowrap;
          height: 3px;
          background-color: #fff;
          border-radius: 8px;
          width: 100%;
          position: absolute;
          top: 50%;
          transition: all ease-out 0.1s;
        }

        &.active-menu {
          &:after {
            transform: rotate(-45deg);
            transform-origin: center;
            top: 50%;
            width: 100%;
          }

          &:before {
            transform: rotate(45deg);
            transform-origin: center;
            top: 50%;
            width: 100%;
          }

          i {
            opacity: 0;
          }
        }
      }
    }

  }
  &_logo {
    width: 100px;
    height: 40px;
    background: url("~@/assets/images/logo_white.svg") no-repeat center;
    background-size: contain;
    @media screen and (max-width: 768px) {
      font-size: 32px;
    }
  }
  &_right {
    width: 90px;
    display: flex;
    justify-content: space-between;
    ::v-deep .dropdown-menu {
      &.dropdown-menu-right {
        transform: translate3d(-128px, 0px, 0px);
        &.show {
          visibility: visible;
          opacity: 1;
          margin-top: 20px;
          transform: translate3d(-128px, 30px, 0px);
        }
      }
    }
    & .header {
      &_user {
        &-content {
          & .dropdown-toggle {
            &:after {
              display: none;
            }
          }

        }
        &-logo {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: url("~@/assets/icons/user_logo.svg");
        }
      }
    }
  }
}
</style>
